import React from 'react';
import styled from 'styled-components';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { deleteAlbum } from '../redux/albumDbSlice';
import { deleteRelationUserAlbum } from '../redux/relationUserAlbumDbSlice';
import { deleteRelationAlbumImage } from '../redux/relationAlbumImageDbSlice';
import useOneAlbumDb from '../hooks/useOneAlbumDb';
import useAllRUAIdsByAlbum from '../hooks/useAllRUAIdsByAlbum';
import useAllRAIIdsByAlbum from '../hooks/useAllRAIIdsByAlbum';

const DeleteTemplateDialogContent = styled(DialogContent)`
  width: 30vw;
`

type DeleteAlbumDialogProps = {
  open: boolean;
  onClose: () => void;
  id: string | undefined;
  updateOrder: (id: string) => void;
  updateSelection: () => void;
}
const DeleteAlbumDialog: React.FC<DeleteAlbumDialogProps> = ({ open, onClose, id, updateOrder, updateSelection }) => {
  const dispatch = useDispatch();
  const album = useOneAlbumDb(id);
  const ruaIds = useAllRUAIdsByAlbum(id);
  const raiIds = useAllRAIIdsByAlbum(id);

  const deleteAlbumExe = () => {
    if (id) {
      updateOrder(id);
      dispatch(deleteAlbum({id: id}));
      ruaIds.forEach(ruaId => dispatch(deleteRelationUserAlbum({id: ruaId})));
      raiIds.forEach(raiId => dispatch(deleteRelationAlbumImage({id: raiId})));
    }
    updateSelection();
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>このアルバムを削除します。アルバム内のすべての画像も削除されますがよろしいですか?</DialogTitle>
      <DeleteTemplateDialogContent style={{overflow: 'hidden'}}>
        {album?.name}
      </DeleteTemplateDialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={() => deleteAlbumExe()}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteAlbumDialog;
